import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Header2 from "../../header2/index-two";
import InstructorSidebar from "../sidebar";
import { AppContext } from "../../../services/AuthContext";
import { getauthorsauthorcustomerrep } from "../../../services/authorService";

const AuthorsCustomerRep = () => {
  const { id } = useParams();
  const { auth } = useContext(AppContext);

  const [contactPersons, setContactPersons] = useState([]);

  // İlgili Kişileri Getir
  const fetchContactPersons = async () => {
    try {
      const data = await getauthorsauthorcustomerrep(id, 1, auth.token);
      if (data && data.status === "OK") {
        setContactPersons(data.data);
      }
    } catch (error) {
      console.error("Error fetching contact persons:", error);
      setContactPersons([]);
    }
  };

  useEffect(() => {
    fetchContactPersons();
  }, []);

  return (
    <div className="main-wrapper mt-5">
      <Header2 />
      <div className="page-content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <InstructorSidebar />
            {/* /Sidebar */}
            <div className="col-xl-9 col-lg-9">
              <div className="settings-widget card-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Yazar Temsilcileri</h3>
                  </div>
                  <div className="checkout-form">
                    <div className="table-responsive custom-table">
                      {/* İlgili Kişiler Tablosu */}
                      <table className="table table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>Ad Soyad</th>
                            <th>E-Posta</th>
                            <th>Görev</th>
                            <th>Kayıt Tarihi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {contactPersons.length > 0 ? (
                            contactPersons.map((person) => (
                              <tr key={person.id}>
                                <td>
                                  {person.user.name} {person.user.surname}
                                </td>
                                <td>{person.user.email || "-"}</td>
                                <td>{person.job || "-"}</td>
                                <td>
                                  {new Date(person.user.regdate).toLocaleDateString() || "-"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                İlgili kişi bulunamadı.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /İlgili Kişiler */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorsCustomerRep;
